<template>
  <router-view></router-view>
</template>

<script>
export default {
  beforeCreate(){
    /**
     * Comprobar la expiracion del token cada vez que inicia la aplicacion cuando se refresca la pagina o se visita por primera vez
     */
    /*
    console.log('beforeCreate');
    console.log(this.$store.state.token);
    if( this.$store.state.token ){
      this.$store.dispatch
    }
    */
  }
}
</script>
